import React, { useState, useEffect, useContext, useCallback, useMemo } from "react";
import "./EmployeeForm.css";
import { Usercontext } from "../../App";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utills/axiosInstance";

const CandidateData = () => {
  const { title, setTitle } = useContext(Usercontext);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [showMarriageDate, setShowMarriageDate] = useState(false);
  const [showDependent, setShowDependent] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const navigate = useNavigate();
  const profile = useMemo(() => JSON.parse(localStorage.getItem('profile') || '{}'), []);

  const initialFormData = {
    firstName: title?.firstName || "",
    lastName: title?.lastName || "",
    candidateId: title?.candidateId || "",
    middleName: title?.middleName || "",
    blood: title?.blood || "",
    department: title?.department || "",
    location: title?.location || "",
    designation: title?.designation || "",
    candidateType: title?.candidateType || "",
    sourceOfHire: title?.sourceOfHire || "",
    dateOfJoining: title?.dateOfJoining || "",
    currentExperience: title?.currentExperience || "",
    totalExperience: title?.totalExperience || "",
    dateOfBirth: title?.dateOfBirth || "",
    age: title?.age || "",
    gender: title?.gender || "",
    maritalStatus: title?.maritalStatus || "",
    aboutMe: title?.aboutMe || "",
    UAN: title?.UAN || "",
    PAN: title?.PAN || "",
    Aadhaar: title?.Aadhaar || "",
    workPhoneNumber: title?.workPhoneNumber || "",
    personalEmailAddress: title?.personalEmailAddress || "",
    presentAddress: title?.presentAddress || "",
    referrerName: title?.referrerName || "",
    referrerMobile: title?.referrerMobile || "",
    educations: title?.educations || [{}],
    experiences: title?.experiences || [{}],
    nameOfParent: title?.nameOfParent || "",
    relationship: title?.relationship || "",
    parentDateOfBirth: title?.parentDateOfBirth || "",
    parentno: title?.parentno || "",
    marriageDate: title?.marriageDate || "",
    nameOfParent2: title?.nameOfParent2 || "",
    relationship2: title?.relationship2 || "",
    parentDateOfBirth2: title?.parentDateOfBirth2 || "",
    parentno2: title?.parentno2 || "",
    file: null
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, desigRes] = await Promise.all([
          axiosInstance.get('/api/departments'),
          axiosInstance.get('/api/designations')
        ]);
        setDepartments(deptRes.data || []);
        setDesignations(desigRes.data || []);
      } catch (error) {
        console.error("There was an error fetching departments/designations:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "maritalStatus" && value === "Married") {
      setShowMarriageDate(true);
    } else if (name === "maritalStatus" && value === "Single") {
      setShowMarriageDate(false);
    }

    if (name === "dateOfBirth") {
      const dob = new Date(value);
      const currentDate = new Date();
      let age = currentDate.getFullYear() - dob.getFullYear();
      const month = currentDate.getMonth() - dob.getMonth();

      if (month < 0 || (month === 0 && currentDate.getDate() < dob.getDate())) {
        age -= 1;
      }

      if (age < 18) {
        alert("You must be at least 18 years old.");
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: "",
          age: "",
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          dateOfBirth: value,
          age: age,
        }));
      }
    }

    if (name === "dateOfJoining") {
      const selectedDate = new Date(value + 'T00:00:00');
      const todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate < new Date()) {
        alert("Date of Joining cannot be in the past.");
        setFormData((prevData) => ({
          ...prevData,
          dateOfJoining: "",
        }));
      }
    }
  };

  const handleEducationChange = useCallback((index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      educations: prev.educations.map((edu, i) =>
        i === index ? { ...edu, [field]: value } : edu
      ),
    }));
  }, []);

  const handleExperienceChange = useCallback((index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      experiences: prev.experiences.map((exp, i) =>
        i === index ? { ...exp, [field]: value } : exp
      ),
    }));
  }, []);

  const handleAddEducation = () => {
    setFormData((prev) => ({
      ...prev,
      educations: [...prev.educations, {}],
    }));
  };

  const handleRemoveEducation = (index) => {
    setFormData((prev) => ({
      ...prev,
      educations: prev.educations.filter((_, i) => i !== index),
    }));
  };

  const handleAddExperience = () => {
    setFormData((prev) => ({
      ...prev,
      experiences: [...prev.experiences, {}],
    }));
  };

  const handleRemoveExperience = (index) => {
    setFormData((prev) => ({
      ...prev,
      experiences: prev.experiences.filter((_, i) => i !== index),
    }));
  };

  const handleAddDependent = () => {
    setShowDependent(!showDependent);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        file: file,
      }));
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setFormData((prev) => ({ ...prev, file: null }));
      setPreviewUrl(null);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const data = new FormData();

    if (!formData.firstName || formData.firstName.length < 3) {
      alert("First Name must be at least 3 characters long.");
      return;
    }
    if (!formData.dateOfJoining) {
      alert("Date of Joining is required.");
      return;
    }

    if (!formData.dateOfBirth) {
      alert("Date of Birth is required.");
      return;
    }

    if (!formData.personalEmailAddress) {
      alert("Personal email is required.");
      return;
    }

    if (!formData.lastName || formData.lastName.length < 3) {
      alert("Last Name must be at least 3 characters long.");
      return;
    }

    if (!formData.candidateId) {
      alert("Employee ID must be a valid number greater than zero.");
      return;
    }

    if (!formData.file) {
      alert("Please select an image file.");
      return;
    }

    if (!formData.personalEmailAddress || !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(formData.personalEmailAddress)) {
      alert("Valid email is required.");
      return;
    }

    if (formData.sourceOfHire === "Employee Referrals") {
      if (!formData.referrerName || formData.referrerName.length < 2) {
        alert("Referrer name is required and must be at least 2 characters.");
        return;
      }
      if (!formData.referrerMobile || !/^\d{10}$/.test(formData.referrerMobile)) {
        alert("Valid referrer mobile number (10 digits) is required.");
        return;
      }
      data.append("referrerName", formData.referrerName);
      data.append("referrerMobile", formData.referrerMobile);
    }

    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("candidateId", formData.candidateId);
    data.append("middleName", formData.middleName);
    data.append("blood", formData.blood);
    data.append("department", formData.department);
    data.append("location", formData.location);
    data.append("designation", formData.designation);
    data.append("candidateType", formData.candidateType);
    data.append("sourceOfHire", formData.sourceOfHire);
    data.append("dateOfJoining", formData.dateOfJoining);
    data.append("currentExperience", formData.currentExperience);
    data.append("totalExperience", formData.totalExperience);
    data.append("dateOfBirth", formData.dateOfBirth);
    data.append("age", formData.age);
    data.append("gender", formData.gender);
    data.append("maritalStatus", formData.maritalStatus);
    data.append("aboutMe", formData.aboutMe);
    data.append("UAN", formData.UAN);
    data.append("PAN", formData.PAN);
    data.append("Aadhaar", formData.Aadhaar);
    data.append("workPhoneNumber", formData.workPhoneNumber);
    data.append("personalEmailAddress", formData.personalEmailAddress);
    data.append("presentAddress", formData.presentAddress);
    data.append("educations", JSON.stringify(formData.educations));
    data.append("experiences", JSON.stringify(formData.experiences));
    data.append("nameOfParent", formData.nameOfParent);
    data.append("relationship", formData.relationship);
    data.append("parentDateOfBirth", formData.parentDateOfBirth);
    data.append("parentno", formData.parentno);
    data.append("marriageDate", formData.marriageDate);
    data.append("nameOfParent2", formData.nameOfParent2);
    data.append("relationship2", formData.relationship2);
    data.append("parentDateOfBirth2", formData.parentDateOfBirth2);
    data.append("parentno2", formData.parentno2);

    if (formData.file) {
      data.append("image", formData.file);
    }

    try {
      const uploadResponse = await axiosInstance.post('/api/createcandidate', data);

      if (uploadResponse.status === 201) {
        navigate("/templates", { state: { candidateData: formData } });
      }
    } catch (error) {
      if (error.response.data.error === "Invalid PAN format") {
        alert("Invalid PAN format");
      }
      alert("Error uploading image. Please try again.");
    }
  };

  const handleCancel = () => {
    // setFormData(initialFormData);
    setShowMarriageDate(false);
    setShowDependent(false);
    setPreviewUrl(null);
    setTitle({ firstName: "", lastName: "", candidateId: "" });
    navigate("/dashboard");
  };

  const getDesignations = (deptName) => {
    if (!deptName) return [];
    return designations.filter(desig => desig.department && desig.department.name === deptName);
  };

  return (
    <>
      <div className="app-container">
        <div className="header-section">
          <h2 className="page-title">Candidate Onboarding Details</h2>
        </div>
        <form className="upload-form" onSubmit={handleUpload}>
          <div className="action-buttons">
            <button type="submit" className="btn btn-primary">
              Save Candidate
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
          </div>

          <div className="form-container">
            {/* Employee Basic Info Section */}
            <section className="form-section">
              <h3 className="section-title">Basic Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="file" className="form-label">
                    Upload Profile Picture <span className="required">*</span>
                  </label>
                  <input
                    type="file"
                    id="file"
                    name="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="form-control"
                    required
                  />
                  {previewUrl && (
                    <img src={previewUrl} alt="Preview" className="image-preview" />
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="candidateId" className="form-label">
                    Candidate Id <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="candidateId"
                    name="candidateId"
                    maxLength={10}
                    value={formData.candidateId}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="firstName" className="form-label">
                    First Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter First Name"
                    pattern="[A-Za-z\s]+"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="middleName" className="form-label">Middle Name</label>
                  <input
                    type="text"
                    id="middleName"
                    name="middleName"
                    pattern="[A-Za-z\s]+"
                    value={formData.middleName}
                    onChange={handleInputChange}
                    placeholder="Enter Middle Name"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName" className="form-label">
                    Last Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter Last Name"
                    pattern="[A-Za-z\s]+"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="blood" className="form-label">
                    Blood Group <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="blood"
                    name="blood"
                    value={formData.blood}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="location" className="form-label">Location</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    pattern="[A-Za-z\s]+"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="Enter Location"
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Employment Details Section */}
            <section className="form-section">
              <h3 className="section-title">Employment Details</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="department" className="form-label">Department</label>
                  <select
                    id="department"
                    name="department"
                    value={formData.department}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Department</option>
                    {departments?.map((department) => (
                      <option key={department._id} value={department.name}>
                        {department.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="designation" className="form-label">Designation</label>
                  <select
                    id="designation"
                    name="designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    className="form-control"
                    disabled={!formData.department}
                  >
                    <option value="">Select Designation</option>
                    {getDesignations(formData.department).map((designation) => (
                      <option key={designation._id} value={designation.name}>
                        {designation.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="candidateType" className="form-label">
                    Candidate Type <span className="required">*</span>
                  </label>
                  <select
                    id="candidateType"
                    name="candidateType"
                    value={formData.candidateType}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Contract">Contract</option>
                    <option value="Intern">Intern</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="sourceOfHire" className="form-label">Source of Hire</label>
                  <select
                    id="sourceOfHire"
                    name="sourceOfHire"
                    value={formData.sourceOfHire}
                    onChange={handleInputChange}
                    className="form-control"
                  >
                    <option value="">Select Source of Hire</option>
                    <option value="Walk-in Drive">Walk-in Drive</option>
                    <option value="Employee Referrals">
                      Employee Referrals
                    </option>
                    <option value="Past Employees">Past Employees</option>
                  </select>
                </div>
                {formData.sourceOfHire === "Employee Referrals" && (
                  <>
                    <div className="form-group">
                      <label htmlFor="referrerName" className="form-label">Referrer Name <span className="required">*</span></label>
                      <input
                        type="text"
                        id="referrerName"
                        name="referrerName"
                        pattern="[A-Za-z\s]+"
                        value={formData.referrerName}
                        onChange={handleInputChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="referrerMobile" className="form-label">Referrer Mobile <span className="required">*</span></label>
                      <input
                        type="tel"
                        id="referrerMobile"
                        name="referrerMobile"
                        pattern="\d{10}"
                        maxLength="10"
                        value={formData.referrerMobile}
                        onChange={handleInputChange}
                        className="form-control"
                        required
                      />
                    </div>
                  </>
                )}
                <div className="form-group">
                  <label htmlFor="dateOfJoining" className="form-label">
                    Date of Joining <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfJoining"
                    name="dateOfJoining"
                    value={
                      formData.dateOfJoining
                        ? new Date(formData.dateOfJoining)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
              </div>
            </section>

            {/* Personal Information Section */}
            <section className="form-section">
              <h3 className="section-title">Personal Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="dateOfBirth" className="form-label">
                    Date of Birth <span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="age" className="form-label">Age</label>
                  <input
                    type="text"
                    id="age"
                    name="age"
                    value={formData.age || ""}
                    className="form-control"
                    disabled
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gender" className="form-label">
                    Gender <span className="required">*</span>
                  </label>
                  <select
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="maritalStatus" className="form-label">
                    Marital Status <span className="required">*</span>
                  </label>
                  <select
                    id="maritalStatus"
                    name="maritalStatus"
                    value={formData.maritalStatus}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select Marital Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
                {showMarriageDate && (
                  <div className="form-group">
                    <label htmlFor="marriageDate" className="form-label">Marriage Date</label>
                    <input
                      type="date"
                      id="marriageDate"
                      name="marriageDate"
                      value={formData.marriageDate}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group full-width">
                  <label htmlFor="aboutMe" className="form-label">About Me</label>
                  <textarea
                    id="aboutMe"
                    name="aboutMe"
                    value={formData.aboutMe}
                    onChange={handleInputChange}
                    rows={3}
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Identity Information Section */}
            <section className="form-section">
              <h3 className="section-title">Identity Information</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="UAN" className="form-label">UAN</label>
                  <input
                    type="password"
                    id="UAN"
                    name="UAN"
                    pattern="\d{12}"
                    maxLength="12"
                    className="form-control"
                    value={formData.UAN}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="PAN" className="form-label">PAN</label>
                  <input
                    type="password"
                    id="PAN"
                    name="PAN"
                    maxLength="10"
                    className="form-control"
                    value={formData.PAN}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="Aadhaar" className="form-label">Aadhaar</label>
                  <input
                    type="password"
                    id="Aadhaar"
                    name="Aadhaar"
                    pattern="\d{12}"
                    maxLength="12"
                    className="form-control"
                    value={formData.Aadhaar}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="workPhoneNumber" className="form-label">
                    Work Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    id="workPhoneNumber"
                    name="workPhoneNumber"
                    pattern="\d{10}"
                    maxLength="10"
                    className="form-control"
                    value={formData.workPhoneNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="personalEmailAddress" className="form-label">
                    Personal Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="personalEmailAddress"
                    name="personalEmailAddress"
                    className="form-control"
                    value={formData.personalEmailAddress}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group full-width">
                  <label htmlFor="presentAddress" className="form-label">
                    Present Address <span className="required">*</span>
                  </label>
                  <textarea
                    id="presentAddress"
                    name="presentAddress"
                    rows="3"
                    className="form-control"
                    value={formData.presentAddress}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            </section>

            {/* Work Experience Section */}
            <section className="form-section">
              <h3 className="section-title">Work Experience</h3>
              <div className="form-grid">
                {formData.experiences.map((exp, index) => (
                  <div key={index} className="experience-block">
                    <h4 className="sub-title">
                      Experience {index + 1}{" "}
                      {formData.experiences.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveExperience(index)}
                          className="btn btn-danger btn-sm"
                        >
                          Remove
                        </button>
                      )}
                    </h4>
                    <div className="form-grid">
                      <div className="form-group">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          name="companyName"
                          pattern="[A-Za-z\s]+"
                          value={exp.companyName || ""}
                          onChange={(e) => handleExperienceChange(index, "companyName", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Job Title</label>
                        <input
                          type="text"
                          name="jobTitle"
                          pattern="[A-Za-z\s]+"
                          value={exp.jobTitle || ""}
                          onChange={(e) => handleExperienceChange(index, "jobTitle", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">From Date</label>
                        <input
                          type="date"
                          name="fromDate"
                          value={exp.fromDate ? new Date(exp.fromDate).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleExperienceChange(index, "fromDate", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">To Date</label>
                        <input
                          type="date"
                          name="toDate"
                          value={exp.toDate ? new Date(exp.toDate).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleExperienceChange(index, "toDate", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group full-width">
                        <label className="form-label">Job Description</label>
                        <textarea
                          name="jobDescription"
                          rows="3"
                          value={exp.jobDescription || ""}
                          onChange={(e) => handleExperienceChange(index, "jobDescription", e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddExperience}
                  className="btn btn-secondary mb-3"
                >
                  Add Experience
                </button>
                <div className="form-group">
                  <label htmlFor="currentExperience" className="form-label">
                    Current Experience (in years)
                  </label>
                  <input
                    type="text"
                    id="currentExperience"
                    name="currentExperience"
                    value={formData.currentExperience}
                    maxLength={2}
                    onChange={handleInputChange}
                    placeholder="Enter Current Experience"
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="totalExperience" className="form-label">
                    Total Experience (in years)
                  </label>
                  <input
                    type="text"
                    id="totalExperience"
                    maxLength={2}
                    name="totalExperience"
                    value={formData.totalExperience}
                    onChange={handleInputChange}
                    placeholder="Enter Total Experience"
                    className="form-control"
                  />
                </div>
              </div>
            </section>

            {/* Education Details Section */}
            <section className="form-section">
              <h3 className="section-title">Education Details</h3>
              <div className="form-grid">
                {formData.educations.map((edu, index) => (
                  <div key={index} className="education-block">
                    <h4 className="sub-title">
                      Education {index + 1}{" "}
                      {formData.educations.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveEducation(index)}
                          className="btn btn-danger btn-sm"
                        >
                          Remove
                        </button>
                      )}
                    </h4>
                    <div className="form-grid">
                      <div className="form-group">
                        <label className="form-label">Institute Name</label>
                        <input
                          type="text"
                          name="instituteName"
                          value={edu.instituteName || ""}
                          pattern="[A-Za-z\s]+"
                          onChange={(e) => handleEducationChange(index, "instituteName", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Degree/Diploma</label>
                        <input
                          type="text"
                          name="degreeDiploma"
                          pattern="[A-Za-z0-9. ]+"
                          value={edu.degreeDiploma || ""}
                          onChange={(e) => handleEducationChange(index, "degreeDiploma", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Specialization</label>
                        <input
                          type="text"
                          name="specialization"
                          pattern="[A-Za-z\s]+"
                          value={edu.specialization || ""}
                          onChange={(e) => handleEducationChange(index, "specialization", e.target.value)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Date of Completion</label>
                        <input
                          type="date"
                          name="dateOfCompletion"
                          value={edu.dateOfCompletion ? new Date(edu.dateOfCompletion).toISOString().split("T")[0] : ""}
                          onChange={(e) => handleEducationChange(index, "dateOfCompletion", e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={handleAddEducation}
                  className="btn btn-secondary mb-3"
                >
                  Add Education
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
};

export default CandidateData;
